module.exports = __webpack_public_path__ + "fonts/Lato-Medium.06e1c8d.ttf";